import { render } from "./Checkout.vue?vue&type=template&id=6412d439"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import "./Checkout.vue?vue&type=style&index=0&id=6412d439&lang=css"
script.render = render

export default script